<template>
  <SearchSuggest :model-value="modelValue" :items="items" placeholder="Search resumes, jobs, companies, skills" empty-title="Your resumes" shortcut
    @update:model-value="$emit('update:modelValue', $event)" />
</template>

<script setup>
import { computed } from 'vue'
import SearchSuggest from '../shared/SearchSuggest.vue'
import { suggestions } from './resumeSearch.js'

// The CV Builder's search: suggestions worked out from the resumes already on the page.
const props = defineProps({
  modelValue: { type: String, default: '' },
  resumes: { type: Array, required: true },
})
defineEmits(['update:modelValue'])

const items = computed(() => suggestions(props.resumes, props.modelValue))
</script>
